import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { Theme } from '@mui/material/styles';
import withStyles from '@mui/styles/withStyles';

const AccordionSummary = withStyles((theme: Theme) => {
  return {
    root: {
      background: 'none',
      paddingLeft: 0,
    },
    content: {
      margin: theme.spacing(2.5, 0),
      [theme.breakpoints.down('md')]: {
        margin: theme.spacing(1.5, 0, 1.5, 0),
      },
    },
    expanded: {
      fontWeight: 'bold',
    },
    expandIconWrapper: {},
  };
})(MuiAccordionSummary);

export default AccordionSummary;
